/* eslint-disable no-nested-ternary */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Decimal from 'decimal.js';
import PropTypes from 'prop-types';
import { Table, Popconfirm } from 'antd';
import dayjs from 'dayjs';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faCopyright } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import MOActions from '@Actions/moActions';
import constants, {
  INFINITE_EXPIRY_DATE, QUANTITY, toISTDate,
} from '@Apis/constants';
import Helpers from '@Apis/helpers';
import AnalyticsActions from '@Actions/application/analyticsActions';
import H3Image from '@Uilib/h3Image';
import UnicommerceIntegrationActions from '@Actions/integrations/unicommerceIntegrationActions';
import ucIcon from '@Images/icons/unicommerce-icon.png';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';
import ViewBatchCustomFields from '../../../../Common/ViewBatchCustomFields';

/**
 * @param withApproval
 */
class BatchSelector extends Component {
  /**
   *
   * @param {*} props
   */
  constructor(props) {
    super(props);

    const { priceMasking } = props;
    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    this.state = {
      batchColumns: [{
        title: '',
        render: (record) => {
          const { expiryDays, uomInfo } = this.props;
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          const shelfLifePct = Math.round(((shelfLife / expiryDays) * 100)) > 100 ? 100 : Math.round(((shelfLife / expiryDays) * 100));
          return (
            <div className="mobile-list__item">
              <H3Text text={`Batch# ${record?.custom_batch_number || record?.batch_number}`} className="mobile-list__item-number" />
              {record?.lot_number && <H3Text text={`Lot# - ${record?.lot_number}`} className="mobile-list__item-info" />}
              {expiryDays >= 0 ? (
                <H3Text
                  text={`Shelf Life# - ${shelfLifePct}% (${shelfLife} Days)`}
                  className="mobile-list__item-info"
                />
              ) : ''}
              {record?.cost_price ? <H3Text text={`Cost Price# - ${record?.cost_price}`} className="mobile-list__item-info" /> : ''}
              <H3Text text={`Quantity - ${QUANTITY(Math.abs(record?.quantity), uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`} className="mobile-list__item-info" />
            </div>
          );
        },
        responsive: ['xs'],
      },
      {
        title: 'Batch#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => {
          const { expiryDays, org } = this.props;
          const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          let shelfLifePct = Math.round(((shelfLife / expiryDays) * 100)) > 100 ? 100 : Math.round(((shelfLife / expiryDays) * 100));
          if (dayjs(record.expiry_date).format('YYYY-MM-DD') === INFINITE_EXPIRY_DATE) shelfLifePct = 100;
          return (
            <div style={{ paddingTop: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div>
                  {record?.custom_batch_number || record?.batch_number}
                </div>
                {record?.subcontractor_grn_id && (
                  <div style={{ marginLeft: '5px', fontSize: '14px', color: '#2d7cf7' }}>
                    <FontAwesomeIcon icon={faCopyright} />
                  </div>
                )}
              </div>

              <div className="table-subscript">
                {dayjs(record.expiry_date).format('YYYY-MM-DD') !== INFINITE_EXPIRY_DATE
                  && <H3Text text={`Expiry ${dayjs(record?.expiry_date).format('DD MMM, YY')}`} />}
                {expiryDays > -1 && (
                  <div className="batch-shelf-life">
                    {dayjs(record.expiry_date).format('YYYY-MM-DD') !== INFINITE_EXPIRY_DATE && expiryDays !== -1 && (
                      <div
                        className="progress-line__wrapper"
                        style={{
                          width: '100px',
                          backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                        }}
                      >
                        <div
                          className="progress-line"
                          style={{
                            width: `${shelfLifePct}%`,
                            backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                          }}
                        />
                      </div>
                    )}
                    <span>
                      {(dayjs(record.expiry_date).format('YYYY-MM-DD') === INFINITE_EXPIRY_DATE || expiryDays === -1) ? 'No Expiry (100%)' : `${shelfLife} Days (${shelfLifePct}%)`}
                    </span>
                  </div>
                )}
              </div>
              <div className="table-subscript">
                {record?.lot_number && batchConfig?.lot_number_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Lot#</span>
                      {' '}
                      {record?.lot_number}
                    </span>
                  )}
                  />
                )}
                {record?.ar_number && batchConfig?.ar_number_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>AR#</span>
                      {' '}
                      {record?.ar_number}
                    </span>
                  )}
                  />
                )}
                {record?.batch_barcode && batchConfig?.batch_barcode_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Barcode</span>
                      {' '}
                      {record?.batch_barcode}
                    </span>
                  )}
                  />
                )}
                {record?.batch_inward_date && batchConfig?.batch_inward_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Inward Date</span>
                      {' '}
                      {dayjs(record?.batch_inward_date).format('DD MMM, YY')}
                    </span>
                  )}
                  />
                )}
                {record?.roll_no && batchConfig?.roll_no_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Roll No#</span>
                      {' '}
                      {record?.roll_no}
                    </span>
                  )}
                  />
                )}
                {record?.brand && batchConfig?.brand_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Brand</span>
                      {' '}
                      {record?.brand}
                    </span>
                  )}
                  />
                )}
                {record?.mfg_batch_no && batchConfig?.mfg_batch_no_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Mfg batch #</span>
                      {' '}
                      {record?.mfg_batch_no}
                    </span>
                  )}
                  />
                )}
                {record?.manufacturing_date && batchConfig?.manufacturing_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Mfg Date</span>
                      {' '}
                      {dayjs(record?.manufacturing_date).format('DD MMM, YY')}
                    </span>
                  )}
                  />
                )}
                {record?.next_qc_date && batchConfig?.next_qc_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Next QC Date</span>
                      {' '}
                      {dayjs(record?.next_qc_date).format('DD MMM, YY')}
                    </span>
                  )}
                  />
                )}
                {record?.last_qc_date && batchConfig?.last_qc_date_is_enabled && (
                  <H3Text text={(
                    <span>
                      <span style={{ color: 'rgb(30, 30, 30)' }}>Last QC Date</span>
                      {' '}
                      {dayjs(record?.last_qc_date).format('DD MMM, YY')}
                    </span>
                  )}
                  />
                )}
              </div>
              <div className="batch-list__item-created-by">
                {`Issued by ${record?.created_by_info?.first_name} ${record?.created_by_info?.last_name?.charAt(0)} on ${toISTDate(record?.modified_at).format('DD MMM, YY')}`}
              </div>
            </div>
          );
        },
        width: '240px',
      },
      {
        title: 'Status',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (item) => (
          <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.status === 'DRAFT' ? 'IN_PROGRESS' : item.status).color }}>
            {Helpers.getStatusColor(item.status === 'DRAFT' ? 'IN_PROGRESS' : item.status).text}
          </div>
        ),
      },
      {
        title: 'Batch Quality',
        render: (text, record) => (['ISSUED', 'CONFIRMED'].includes(record.status) ? (
          <div className="qr__status" style={{ backgroundColor: record?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
            {record?.is_rejected_batch ? 'Bad' : 'Good'}
          </div>
        ) : '-'),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Costing',
        render: (text, record) => {
          const { org } = this.props;
          const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
          return (
            <div className="table-subscript">
              {record?.mrp > 0 && batchConfig?.mrp_is_enabled && (
                <H3Text text={(
                  <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                  }}
                  >
                    <div style={{ color: 'rgb(30, 30, 30)' }}>MRP</div>
                    <div>
                      {this.props.MONEY(record?.mrp)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.cost_price > 0 && batchConfig?.cost_price_is_enabled && (
                <H3Text text={(
                  <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                  }}
                  >
                    <div style={{ color: 'rgb(30, 30, 30)' }}>Cost Price</div>
                    <div>
                      {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view cost price"} /> : this.props.MONEY(record?.cost_price)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.freight_cost > 0 && batchConfig?.freight_cost_is_enabled && (
                <H3Text text={(
                  <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                  }}
                  >
                    <div style={{ color: 'rgb(30, 30, 30)' }}>Freight Cost</div>
                    <div>
                      {this.props.MONEY(record?.freight_cost)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.other_cost > 0 && batchConfig?.other_cost_is_enabled && (
                <H3Text text={(
                  <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                  }}
                  >
                    <div style={{ color: 'rgb(30, 30, 30)' }}>Other Cost</div>
                    <div>
                      {this.props.MONEY(record?.other_cost)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.landed_cost > 0 && batchConfig?.landed_cost_is_enabled && (
                <H3Text text={(
                  <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                  }}
                  >
                    <div style={{ color: 'rgb(30, 30, 30)' }}>Landed Cost</div>
                    <div>
                      {(isDataMaskingPolicyEnable && isHideCostPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view landed cost"} /> : this.props.MONEY(record?.landed_cost)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.selling_price > 0 && batchConfig?.selling_price_is_enabled && (
                <H3Text text={(
                  <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                  }}
                  >
                    <div style={{ color: 'rgb(30, 30, 30)' }}>Selling Price</div>
                    <div>
                      {(isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view selling price"} /> : this.props.MONEY(record?.selling_price)}
                    </div>
                  </div>
                )}
                />
              )}
              {record?.selling_price > 0 && record?.landed_cost > 0 && batchConfig?.margin_is_enabled && (
                <H3Text text={(
                  <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontWeight: '600',
                  }}
                  >
                    <div style={{ color: 'rgb(30, 30, 30)' }}>Margin</div>
                    <div>
                      {this.props.MONEY(record?.selling_price - record?.landed_cost)}
                    </div>
                  </div>
                )}
                />
              )}
            </div>
          );
        },
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Quantity',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => {
          const { uomInfo, row } = this.props;
          return (
            <Fragment>
              <div>{`${QUANTITY(Math.abs(record?.quantity), uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()}`}</div>
              {!record?.is_rejected_batch ? (
                <div style={{
                  color: '#c91c1c',
                  fontSize: '10px',
                  fontWeight: '500',
                }}
                >
                  {Math.abs(record?.quantity || 0) > 0 && Math.abs(record?.quality_checks?.[0]?.sample_quantity || 0) > 0 && (
                    <React.Fragment>
                      {` + ${QUANTITY(Math.abs(record?.initial_quantity || record?.quantity) - Math.abs(record?.quantity || 0) - Math.abs(Number(record?.quality_checks?.[0]?.sample_quantity) || 0), uomInfo?.precision)} ${uomInfo?.uqc?.toProperCase()} Rejected`}
                      <br />
                      {` + ${QUANTITY(Math.abs(record.quality_checks[0].sample_quantity))} ${uomInfo?.uqc?.toProperCase()} Sample Quantity`}
                    </React.Fragment>
                  )}
                </div>
              ) : ''}
            </Fragment>
          );
        },
      },
      {
        title: 'Custom Fields',
        render: (record) => (<ViewBatchCustomFields customFields={record?.custom_fields} />),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: '',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (record) => {
          const {
            updateMOAdjustmentStatus, match, getMOById, user, showCancel, status, callback, downloadDocument,
            adjustUnicommerceInventory, adjustUnicommerceInventoryLoading, unicommerceInfo,
          } = this.props;
          const { moId } = match.params;
          const createdAtDate = dayjs(record?.created_at);
          return (
            record.status !== 'VOID' && (
              <div className="fp-table-delete-button">
                {
                  (status !== 'COMPLETED') && (showCancel ? !record?.subcontractor_grn_id : !record?.subcontractor_invoice_id) && (
                    <Popconfirm
                      placement="topRight"
                      title={showCancel ? 'Are you sure you want to cancel the batch?' : 'Are you sure you want to revert the batch?'}
                      onConfirm={() => updateMOAdjustmentStatus([{
                        mo_adjustment_id: record?.mo_adjustment_id,
                        mo_id: moId,
                        status: 'VOID',
                      }], () => {
                        if (callback) {
                          callback();
                        } else getMOById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ).join(','), moId);
                      })}
                      okText="Yes"
                      cancelText="No"
                      disabled={status === 'COMPLETED'}
                    >
                      <div className={showCancel ? 'generic-cancel-button' : 'generic-revert-button'}>
                        {showCancel ? <CloseOutlined /> : 'Revert'}
                      </div>
                    </Popconfirm>
                  )
                }
                {(record.status === 'ISSUED') && !(record?.is_rejected_batch) && (record?.entity_type === 'FINISHED_GOOD') && (
                  <div
                    className="batch-bmr-button"
                    onClick={() => downloadDocument({
                      url: `${constants.MO}/bmr_report?mo_adjustment_id=${record?.mo_adjustment_id}`,
                      document_type: 'BATCH_MANUFACTURING_RECORD',
                      document_number: record?.batch_number,
                      key: uuidv4(),
                    })}
                  >
                    <H3Text
                      text={(
                        <Fragment>
                          <FontAwesomeIcon
                            icon={faDownload}
                            className="action-button-text"
                          />
                        </Fragment>
                      )}
                      className="action-button"
                    />
                  </div>
                )}
                {(record.status === 'ISSUED') && (record?.entity_type === 'FINISHED_GOOD') && unicommerceInfo?.ucSkuCode && record?.batch_id && (
                  <Popconfirm
                    placement="topRight"
                    title={record?.unicommerce_pushed_at ? `Batch pushed to unicommerce at ${toISTDate(record?.uncommerce_pushed_at).format('DD/MM/YYYY hh:mm A')}` : 'Are you sure you want to push this batch to Unicommerce?'}
                    onConfirm={() => adjustUnicommerceInventory(
                      [{
                        tenant_product_id: record?.tenant_product_id,
                        unicommerce_sku_code: unicommerceInfo?.ucSkuCode,
                        quantity: record?.quantity,
                        inventory_type: `${record?.is_rejected_batch ? 'BAD' : 'GOOD'}_INVENTORY`,
                        adjustment_type: 'ADD',
                        facility_code: unicommerceInfo?.facilityCode,
                        entity_number: unicommerceInfo?.entityNumber,
                        entity_name: unicommerceInfo?.entityName,
                        batch_id: record?.batch_id,
                        mo_adjustment_id: record?.mo_adjustment_id,
                      }],
                      () => {
                        if (callback) {
                          callback();
                        } else getMOById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.MO, Helpers.permissionTypes.READ).join(','), moId);
                      },
                    )}
                    okText="Yes"
                    cancelText="No"
                    okButtonProps={{
                      hidden: record?.unicommerce_pushed_at,
                    }}
                    cancelButtonProps={{
                      hidden: record?.unicommerce_pushed_at,
                    }}
                  >
                    <div className="batch-uc-button">
                      {adjustUnicommerceInventoryLoading ? <LoadingOutlined /> : <H3Image src={ucIcon} className="" />}
                      <div className={record?.unicommerce_pushed_at ? 'green-indicator' : 'red-indicator'} />
                    </div>
                  </Popconfirm>
                )}
              </div>
            )
          );
        },
        fixed: 'right',
        className: `mo-batch-selector__actions`,
      },
      ],
    };
  }

  getBatches(oldBatches, quantity) {
    const batches = oldBatches;
    let remainingQty = new Decimal(quantity);
  
    for (let i = 0; i < batches?.length; i++) {
      batches[i].consumed_qty = 0;
    }
  
    for (let i = 0; i < batches?.length; i++) {
      const availableQty = new Decimal(batches[i]?.available_qty || 0);
      const consumedQty = new Decimal(batches[i]?.consumed_qty || 0);
  
      if (remainingQty.gt(0) && consumedQty.lt(availableQty)) {
        const qtyToConsume = Decimal.min(availableQty, remainingQty);
        batches[i].consumed_qty = qtyToConsume.toNumber();
        remainingQty = remainingQty.minus(qtyToConsume);
      } else {
        batches[i].consumed_qty = 0;
        remainingQty = remainingQty.minus(new Decimal(batches[i].consumed_qty));
      }
    }
    return batches;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      batches, title, updateMOAdjustmentStatusLoading, adjustUnicommerceInventoryLoading,
    } = this.props;
    const { batchColumns } = this.state;
    return (
      <div className="batch-selector-wrapper">
        <H3Text text={title} className="batch-selector-title" />
        <Table
          size="small"
          columns={batchColumns}
          dataSource={batches}
          pagination={false}
          loading={updateMOAdjustmentStatusLoading || adjustUnicommerceInventoryLoading}
          scroll={{ x: 'max-content' }}
          bordered
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers, MOReducers, UnicommerceIntegrationReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateMOAdjustmentStatusLoading: MOReducers.updateMOAdjustmentStatusLoading,
  adjustUnicommerceInventoryLoading: UnicommerceIntegrationReducers.adjustUnicommerceInventoryLoading,
  org: UserReducers.org,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  updateMOAdjustmentStatus: (payload, callback) => dispatch(MOActions.updateMOAdjustmentStatus(payload, callback)),
  getMOById: (tenantId, moId) => dispatch(MOActions.getMOById(tenantId, moId)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
  adjustUnicommerceInventory: (payload, callback) => dispatch(UnicommerceIntegrationActions.adjustUnicommerceInventory(payload, callback)),
});
BatchSelector.propTypes = {
  expiryDays: PropTypes.any,
  batches: PropTypes.any,
  uomInfo: PropTypes.any,
  title: PropTypes.any,
  showCancel: PropTypes.bool,
  showRevert: PropTypes.bool,
  updateMOAdjustmentStatusLoading: PropTypes.bool,
  updateMOAdjustmentStatus: PropTypes.func,
  match: PropTypes.func,
  getMOById: PropTypes.any,
  user: PropTypes.any,
  isFinishedGood: PropTypes.bool,
  row: PropTypes.any,
  status: PropTypes.any,
  isContractOrder: PropTypes.any,
  unicommerceInfo: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BatchSelector));
